import { jsx as g } from "react/jsx-runtime";
import { getStylesFromSelectors as t, createClassNameSelectors as d } from "../../../utils/classNameSelectors.js";
import "../../../utils/sectionPreview.js";
import e from "react";
import x from "clsx";
import { isFragment as m } from "react-is";
import '../../../_assets/Row.i8-6KdoE.css';const u = "_row_19sld_44", c = "_rowWithGutter_19sld_49", _ = {
  row: u,
  rowWithGutter: c,
  "row--align-xxs-left": "_row--align-xxs-left_19sld_79",
  "row--align-xxs-center": "_row--align-xxs-center_19sld_82",
  "row--align-xxs-right": "_row--align-xxs-right_19sld_85",
  "row--align-xxs-between": "_row--align-xxs-between_19sld_88",
  "row--align-xxs-around": "_row--align-xxs-around_19sld_91",
  "row--align-xxs-evenly": "_row--align-xxs-evenly_19sld_94",
  "row--align-xs-left": "_row--align-xs-left_19sld_99",
  "row--align-xs-center": "_row--align-xs-center_19sld_102",
  "row--align-xs-right": "_row--align-xs-right_19sld_105",
  "row--align-xs-between": "_row--align-xs-between_19sld_108",
  "row--align-xs-around": "_row--align-xs-around_19sld_111",
  "row--align-xs-evenly": "_row--align-xs-evenly_19sld_114",
  "row--align-s-left": "_row--align-s-left_19sld_119",
  "row--align-s-center": "_row--align-s-center_19sld_122",
  "row--align-s-right": "_row--align-s-right_19sld_125",
  "row--align-s-between": "_row--align-s-between_19sld_128",
  "row--align-s-around": "_row--align-s-around_19sld_131",
  "row--align-s-evenly": "_row--align-s-evenly_19sld_134",
  "row--align-ssm-left": "_row--align-ssm-left_19sld_139",
  "row--align-ssm-center": "_row--align-ssm-center_19sld_142",
  "row--align-ssm-right": "_row--align-ssm-right_19sld_145",
  "row--align-ssm-between": "_row--align-ssm-between_19sld_148",
  "row--align-ssm-around": "_row--align-ssm-around_19sld_151",
  "row--align-ssm-evenly": "_row--align-ssm-evenly_19sld_154",
  "row--align-sm-left": "_row--align-sm-left_19sld_159",
  "row--align-sm-center": "_row--align-sm-center_19sld_162",
  "row--align-sm-right": "_row--align-sm-right_19sld_165",
  "row--align-sm-between": "_row--align-sm-between_19sld_168",
  "row--align-sm-around": "_row--align-sm-around_19sld_171",
  "row--align-sm-evenly": "_row--align-sm-evenly_19sld_174",
  "row--align-m-left": "_row--align-m-left_19sld_179",
  "row--align-m-center": "_row--align-m-center_19sld_182",
  "row--align-m-right": "_row--align-m-right_19sld_185",
  "row--align-m-between": "_row--align-m-between_19sld_188",
  "row--align-m-around": "_row--align-m-around_19sld_191",
  "row--align-m-evenly": "_row--align-m-evenly_19sld_194",
  "row--align-xm-left": "_row--align-xm-left_19sld_199",
  "row--align-xm-center": "_row--align-xm-center_19sld_202",
  "row--align-xm-right": "_row--align-xm-right_19sld_205",
  "row--align-xm-between": "_row--align-xm-between_19sld_208",
  "row--align-xm-around": "_row--align-xm-around_19sld_211",
  "row--align-xm-evenly": "_row--align-xm-evenly_19sld_214",
  "row--align-l-left": "_row--align-l-left_19sld_219",
  "row--align-l-center": "_row--align-l-center_19sld_222",
  "row--align-l-right": "_row--align-l-right_19sld_225",
  "row--align-l-between": "_row--align-l-between_19sld_228",
  "row--align-l-around": "_row--align-l-around_19sld_231",
  "row--align-l-evenly": "_row--align-l-evenly_19sld_234",
  "row--align-xl-left": "_row--align-xl-left_19sld_239",
  "row--align-xl-center": "_row--align-xl-center_19sld_242",
  "row--align-xl-right": "_row--align-xl-right_19sld_245",
  "row--align-xl-between": "_row--align-xl-between_19sld_248",
  "row--align-xl-around": "_row--align-xl-around_19sld_251",
  "row--align-xl-evenly": "_row--align-xl-evenly_19sld_254",
  "row--align-xxl-left": "_row--align-xxl-left_19sld_259",
  "row--align-xxl-center": "_row--align-xxl-center_19sld_262",
  "row--align-xxl-right": "_row--align-xxl-right_19sld_265",
  "row--align-xxl-between": "_row--align-xxl-between_19sld_268",
  "row--align-xxl-around": "_row--align-xxl-around_19sld_271",
  "row--align-xxl-evenly": "_row--align-xxl-evenly_19sld_274",
  "slide-in-out": "_slide-in-out_19sld_1",
  "fade-in-out": "_fade-in-out_19sld_1"
}, f = (n, r) => n ? e.Children.map(r, (l) => !e.isValidElement(l) || m(l) ? l : e.cloneElement(l, {
  noGutter: n
})) : r, G = (n) => {
  const { className: r, children: l, align: o, noGutter: s, as: i = "div", ...a } = n, w = x(
    o ? t(d("row--align", o, "left"), _) : null,
    s ? _.row : _.rowWithGutter,
    r
  );
  return /* @__PURE__ */ g(i, { className: w, ...a, children: f(!!s, l) });
};
export {
  G as Row
};
